module.exports = __webpack_public_path__ + "static/media/terms-banner.4dd23b38.svg";